/* Kröll Systeme · Bewertungsplatten-Shop · Verhalten der kc-* Sections.
   Nur zwei Dinge: Einblenden beim Scrollen und der Kaufblock (Preis folgt der Menge).
   Kein Tracking, kein Speicher auf dem Gerät. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('.kc-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function buyForms() {
    document.querySelectorAll('[data-kc-buy]').forEach(function (form) {
      var priceOut = form.querySelector('[data-kc-price]');
      var btnPrice = form.querySelector('[data-kc-btn-price]');
      var opts = form.querySelectorAll('input[name="id"]');
      function sync() {
        var on = form.querySelector('input[name="id"]:checked');
        if (!on) return;
        var price = on.getAttribute('data-price');
        if (priceOut) priceOut.textContent = price;
        if (btnPrice) btnPrice.textContent = price;
      }
      opts.forEach(function (o) { o.addEventListener('change', sync); });
      sync();
    });
  }

  function init() { reveal(); buyForms(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
